import { createContext, useContext } from 'react';

export const TranslationContext = createContext(
  {} as { changeLanguage: (language: string) => void },
);

export const useTranslationContext = () => useContext(TranslationContext);
